
















import { ref, createComponent, Ref, onMounted } from '@vue/composition-api'
// import SliceUploader from "../components/SliceUploader.vue";
export default createComponent({
    components: {
        // SliceUploader
    },
    setup(props, setupContext) {
        const fn = res => {
            if (res.code === 0) {
                return true
            }
            return false
        }
        const fn1 = res => {
            let data = []
            if (res.data && res.data.length) {
                data = res.data.map(v => {
                    // 后台索引是1开始的
                    return v - 1
                })
            }
            return data
        }
        const fn2 = (res, file) => {
            console.log('on-file-save-success', res, file)
        }
        const fn3 = (res, file) => {
            console.log('on-file-save-error', res, file)
        }
        const fn4 = (res, file) => {
            console.log('on-file-send-error', res, file)
        }
        const fn5 = file => {
            console.log('pause', file)
        }
        const fn6 = file => {
            console.log('resume', file)
        }
        const fn7 = file => {
            console.log('remove', file)
        }
        return {
            fn,
            fn1,
            fn2,
            fn3,
            fn4,
            fn5,
            fn6,
            fn7,
        }
    },
})
